var _rect, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconDetail = function SvgIconDetail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FF9800"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.23007 5.08983C7.96839 5.39164 7.98584 5.83247 8.28242 6.11572L14.6569 11.996L8.28555 17.8746C7.9569 18.1778 7.9569 18.6712 8.28554 18.9744C8.61176 19.2753 9.13862 19.2753 9.46477 18.9744L16.4326 12.5465C16.7612 12.2433 16.7612 11.7499 16.4326 11.4467L9.46478 5.01881C9.12982 4.72033 8.60292 4.72879 8.2824 5.03495L8.23007 5.08983Z",
    fill: "#FAFAFA"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconDetail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_detail.d6c763ed.svg";
export { ForwardRef as ReactComponent };